import { Directive, TemplateRef, inject } from '@angular/core';
import { type SelectRowContext, type SelectTriggerContext } from './multi-select-button.types';

@Directive({ selector: 'ng-template[appSelectRow]' })
export class SelectRowTemplateDirective {
  public readonly template = inject<TemplateRef<SelectRowContext>>(TemplateRef);

  public static ngTemplateContextGuard(
    _directive: SelectRowTemplateDirective,
    _context: unknown,
  ): _context is SelectRowContext {
    return true;
  }
}

@Directive({ selector: 'ng-template[appSelectTrigger]' })
export class SelectTriggerTemplateDirective {
  public readonly template = inject<TemplateRef<SelectTriggerContext>>(TemplateRef);

  public static ngTemplateContextGuard(
    _directive: SelectTriggerTemplateDirective,
    _context: unknown,
  ): _context is SelectTriggerContext {
    return true;
  }
}
